module.exports = __webpack_public_path__ + "img/australia.3d9e1072.png";